import { useCanvas } from '../state/canvas-store.js';
import { TEMPLATES } from './templates.js';

interface Props {
  open: boolean;
  onClose: () => void;
}

export const TemplateGallery = ({ open, onClose }: Props) => {
  const loadFromJSON = useCanvas((s) => s.loadFromJSON);
  const elements = useCanvas((s) => s.elements);

  if (!open) return null;

  const insert = (id: string) => {
    const t = TEMPLATES.find((x) => x.id === id);
    if (!t) return;
    const hasContent = elements.some((e) => !e.isDeleted);
    if (hasContent && !confirm('Ganti canvas dengan template ini? Data belum di-save akan hilang.')) return;
    loadFromJSON({ elements: t.build() });
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 grid place-items-center bg-black/40" onClick={onClose}>
      <div
        className="w-[720px] max-w-[92vw] rounded-xl bg-white dark:bg-neutral-900 shadow-2xl ring-1 ring-black/10 p-5 flex flex-col gap-4"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between">
          <h2 className="text-base font-semibold text-neutral-800 dark:text-neutral-100">Template gallery</h2>
          <button className="text-neutral-500 text-lg" onClick={onClose}>×</button>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
          {TEMPLATES.map((t) => (
            <button
              key={t.id}
              onClick={() => insert(t.id)}
              className="text-left rounded-lg border border-neutral-200 dark:border-neutral-700 bg-neutral-50 dark:bg-neutral-800 hover:bg-neutral-100 dark:hover:bg-neutral-700 transition-colors p-3 flex flex-col gap-1"
            >
              <div className="text-sm font-semibold text-neutral-800 dark:text-neutral-100">{t.label}</div>
              <div className="text-xs text-neutral-500 dark:text-neutral-400">{t.description}</div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
